<div class="wrapper">
  @if (actorName() === 'System') {
    <div class="system-avatar">
      <ui-svg-icon
        icon="none"
        nuiIcon="logo-colored"
        size="sm" />
    </div>
  } @else {
    <ui-avatar
      size="sm"
      [text]="avatarText()"
      [rounded]="true"
      [style.--background-color]="senderId() | nsAvatarColor"
      class="avatar" />
  }
  <div class="content">
    <div class="header">
      <span
        class="user-name"
        nuiTypography="nui-title">
        {{ actorName() }}
      </span>
      <span class="separator">·</span>
      <span
        class="time-since"
        nuiTypography="nui-body"
        uiSize="sm"
        [uiTooltip]="createdTime()">
        {{ timeSince() }}
      </span>
      <ns-read-status-marker [notification]="notification()" />
    </div>
    <div class="action-group">
      <div class="action">
        <ui-label
          type="secondary"
          weight="bold"
          size="xs"
          [leadingIcon]="actionIcon()">
          {{ title() }}
        </ui-label>
      </div>
      @if (descriptionContent(); as _descriptionContent) {
        <div
          class="description-content"
          nuiTypography="nui-body"
          [innerHtml]="_descriptionContent"></div>
      }
    </div>
    <div
      class="details"
      uiSize="sm">
      @let _sourceName = sourceName();
      @if (_sourceName) {
        <span
          #sourceName
          class="source-name"
          nuiTypography="nui-body"
          [uiTooltip]="_sourceName"
          [uiTooltipDisabled]="
            sourceName.clientWidth >= sourceName.scrollWidth
          ">
          {{ _sourceName }}
        </span>
      }
      @let _link = link();
      @let _linkCaption = linkCaption();
      @if (_link && _linkCaption) {
        @if (_sourceName) {
          <span class="separator">·</span>
        }
        <a
          (click)="handleCaptionClick($event)"
          href="{{ _link }}"
          uiLink>
          {{ _linkCaption }}
        </a>
      }
    </div>
  </div>
</div>
